import styled from "styled-components";

const MemberContainer = styled.div`
    background-color: #fff;
`;

export default MemberContainer;